/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';

// context imports
import { AuthContext } from '../../contexts/AuthContext'
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';
import AuthService from '../../services/AuthService';

// local imports
import GeneralNavbar from '../general/GeneralNavbar';
import ErrorBoundary from '../general/ErrorBoundary';
import Message from '../general/Message';

const ForgotPassword = props => {

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);

    // states
    const [email, setEmail] = useState();
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    let timerID = useRef(null);

    useEffect(() => {
        if (props.location.search) {
            setEmail(props.location.search.substr(7));
        }
        return () => {
            clearTimeout(timerID)
        }
    }, [])

    // handle functions
    const handleChange = e => {
        try {
            setEmail(e.target.value);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User ForgotPassword handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading(true);
            AuthService.forgotPassword(email)
                .then(data => {
                    setEmail("");
                    setMessage(data.message);
                    setIsLoading(false);
                })
                .catch(error => {
                    setMessage(error.message);
                    setIsLoading(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at User ForgotPassword handleSubmit', 'Error in try catch block', err.stack);
        }
    }


    // function's return
    return (
        <div>
            <ErrorBoundary errorAt="At User SignIn GeneralNavbar">
                <GeneralNavbar history={props.history} isSignInPage={true} />
            </ErrorBoundary>
            <div className="p-3 col-md-4 mt-5 mb-5 offset-md-4" style={theme.form}>
                <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                    <h2 id="forgot-password-heading" style={theme.heading}>Forgot password</h2>
                    <br />

                    <ErrorBoundary errorAt="At User ForgotPassword Message">
                        {message ? <Message message={message} /> : null}
                    </ErrorBoundary>

                    <label htmlFor="email" style={theme.formBodyText} >Email </label>
                    <input type="text"
                        name="email"
                        value={email}
                        onChange={handleChange}
                        className="form-control"
                        required
                        style={theme.formInput}
                    />
                    <br />

                    <button className="btn mt-2" type="submit" style={theme.formSubmit} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</button>

                    <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm, marginTop: "10px" }}>
                        Don't have an account?
                        <Link to="/user/signup">
                            <span style={{ color: colors.primaryGreenDark, fontWeight: fontWeight.bold }}> Sign Up here</span>
                        </Link>
                    </p>
                </form>
            </div>
        </div>
    )


}

export default ForgotPassword;